import Grid from "@mui/material/Grid";
import { Box, Stack } from "@mui/material";
import { LabelTemplate } from "./styles/table";
import { Employee } from "../types/processTypes";

import { BasicPostApplied } from "./components/basic/BasicPostApplied";
import { BasicDetail } from "./components/basic/BasicDetail";
import { BasicLanguage } from "./components/basic/BasicLanguage";
import { BasicExperience } from "./components/basic/BasicExperience";
import { BasicSkillsOneLineHorz } from "./components/basic/BasicSkills";
import { BasicPassport } from "./components/basic/BasicPassport";
import { BasicFullName } from "./components/basic/BasicFullName";
import { BasicFace } from "./components/basic/BasicFace";
import { BasicStand } from "./components/basic/BasicStand";
import { BasicPassportScan } from "./components/basic/BasicPassportScan";
import { BasicHeader } from "./components/basic/BasicHeader";
import { Company } from "../../setups/types/setupTypes";
import { BasicTitleSingleLang } from "./components/basic/BasicTitle";

interface Props {
  selectedCompany: Company;
  currentEmployee: Employee;
  backgroundColor: string;
  cvTemplate: LabelTemplate;
}
function BasicThreeTemplate({
  selectedCompany,
  currentEmployee,
  backgroundColor,
  cvTemplate,
}: Props) {
  //a08745;f2f1f0 fffcf2
  return (
    <>
      <Box id="personalData" sx={{ p: 1 }}>
        <Grid
          container
          spacing={cvTemplate.spacing}
          sx={{
            p: 1,
            backgroundColor: backgroundColor,
          }}
        >
          <Grid
            item
            xs={12}
            sx={{
              height: "90%",
              mb: 1,
            }}
          >
            {cvTemplate && currentEmployee && (
              <BasicHeader
                selectedCompany={selectedCompany}
                currentEmployee={currentEmployee}
                template={cvTemplate}
              />
            )}
          </Grid>
          <Grid
            container
            item
            xs={12}
            spacing={cvTemplate.spacing}
            justifyContent="center"
            alignItems="center"
          >
            {/* Short Photo */}

            <Grid container item xs={9}>
              {cvTemplate && currentEmployee && (
                <>
                  <Grid item xs={12}>
                    <BasicTitleSingleLang template={cvTemplate} />
                  </Grid>

                  <Grid item xs={12} sx={{ mt: 1 }}>
                    <BasicFullName
                      currentEmployee={currentEmployee}
                      template={cvTemplate}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <BasicPostApplied
                      currentEmployee={currentEmployee}
                      template={cvTemplate}
                      showHeader={false}
                      showProfession={true}
                      showSalary={false}
                      showContractPeriod={false}
                      showEmployeeTelephone={true}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <BasicDetail
                      currentEmployee={currentEmployee}
                      template={cvTemplate}
                      showHeader={false}
                      showReference={false}
                      showNationality={false}
                      showPassportNumber={false}
                      showReligion={false}
                      showDateOfBirth={false}
                      showAge={true}
                      showPlaceOfBirth={false}
                      showMaritalStatus={false}
                      showNumberOfChildren={false}
                      showWeightHeight={false}
                      showComplexion={false}
                      showEducation={false}
                      showLivingTown={false}
                      showEmployeeTelephone={false}
                      showContactName={false}
                      showContactTelephone={false}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <BasicPassport
                      currentEmployee={currentEmployee}
                      template={cvTemplate}
                      showHeader={false}
                      showPassportNumber={false}
                      showIssueDate={false}
                      showPlaceOfIssue={false}
                      showExpiryDate={true}
                    />
                  </Grid>
                </>
              )}
            </Grid>

            <Grid item xs={3}>
              {cvTemplate && currentEmployee && (
                <BasicFace
                  currentEmployee={currentEmployee}
                  template={cvTemplate}
                />
              )}
            </Grid>
          </Grid>

          <Grid item md={6} xs={12}>
            {cvTemplate && currentEmployee && (
              <>
                <BasicDetail
                  currentEmployee={currentEmployee}
                  template={cvTemplate}
                  showHeader={true}
                  showReference={true}
                  showNationality={true}
                  showPassportNumber={true}
                  showReligion={true}
                  showDateOfBirth={true}
                  showAge={false}
                  showPlaceOfBirth={true}
                  showMaritalStatus={true}
                  showNumberOfChildren={true}
                  showWeightHeight={true}
                  showComplexion={false}
                  showEducation={false}
                  showLivingTown={false}
                  showEmployeeTelephone={true}
                  showContactName={false}
                  showContactTelephone={false}
                />

                <BasicLanguage
                  currentEmployee={currentEmployee}
                  template={cvTemplate}
                  showEducation={true}
                />

                <BasicExperience
                  currentEmployee={currentEmployee}
                  template={cvTemplate}
                  type="basic"
                />
              </>
            )}
          </Grid>
          <Grid item md={6} xs={12}>
            {cvTemplate && currentEmployee && (
              <Stack
                spacing={cvTemplate.spacing}
                sx={{
                  alignItems: "center",
                }}
              >
                <BasicStand
                  currentEmployee={currentEmployee}
                  template={cvTemplate}
                />
              </Stack>
            )}
          </Grid>
          <Grid item xs={12}>
            {cvTemplate && currentEmployee && (
              <BasicSkillsOneLineHorz
                currentEmployee={currentEmployee}
                template={cvTemplate}
              />
            )}
          </Grid>
        </Grid>
      </Box>
      <Stack
        id="passportData"
        sx={{
          p: 1,
          pt: 1,
          backgroundColor: backgroundColor,
          minHeight: "1500px",
        }}
      >
        {cvTemplate.addPassportHeader && (
          <Box
            sx={{
              height: "90%",
            }}
          >
            {cvTemplate && currentEmployee && (
              <BasicHeader
                selectedCompany={selectedCompany}
                currentEmployee={currentEmployee}
                template={cvTemplate}
              />
            )}
          </Box>
        )}
        {cvTemplate && currentEmployee && (
          <Box
            sx={{
              mt: 15,
            }}
          >
            <BasicPassportScan
              currentEmployee={currentEmployee}
              template={cvTemplate}
            />
          </Box>
        )}
      </Stack>
    </>
  );
}

export default BasicThreeTemplate;
